import { styled, css } from "../../../styled-components";

export const Smartphone = styled.div<{ round: number }>`
    position: relative;
    ${p =>
        css`
            border-radius: ${p.round}px;
        `}
    box-shadow: 0px 36px 42px rgba(0, 0, 0, 0.1);
    width: 375px;
    min-width: 375px;
    max-height: 812px;
    height: 100%;
    overflow: hidden;

    transform: translate3d(0, 0, 0);

    #loader-1 {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
